import {motion} from "framer-motion";
import {fadeVariants} from "../../../utils/theme";
import {FlexCenter} from "../../../styles/CommonStyles";
import RTradingComp from "../RTradingComp";
import OrdersBook from "../../orderbox/OrdersBook";
import OrdersHistory from "../../orders-history/OrdersHistory";
import TradingChart from "../../chart/TradingChart";


const RTrade = () => {

    return (
        <motion.div
            variants={fadeVariants}
            initial={'out'}
            animate={'in'}
            exit={'out'}
        >
            <FlexCenter style={{ alignItems: "stretch" }}>
                <FlexCenter width="50%" height="unset">
                    <RTradingComp />
                </FlexCenter>
                <FlexCenter width="50%" height="unset">
                    <OrdersBook />
                </FlexCenter>
            </FlexCenter>
            <OrdersHistory />
            <FlexCenter>
                <TradingChart />
            </FlexCenter>
        </motion.div>
    )
}

export default RTrade
